// extracted by mini-css-extract-plugin
export var container = "_n8-0";